var _path, _path2, _g, _g2, _path3, _rect, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScreenerLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 6H24V44H6C3.79086 44 2 42.2091 2 40V6Z",
    fill: "url(#paint0_linear_396_11251)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 6H46V40C46 42.2091 44.2091 44 42 44H24V6Z",
    fill: "url(#paint1_linear_396_11251)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_396_11251)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 5.79086 1.79086 4 4 4H24V28H4C1.79086 28 0 26.2091 0 24V8Z",
    fill: "url(#paint2_linear_396_11251)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_396_11251)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 4H44C46.2091 4 48 5.79086 48 8V24C48 26.2091 46.2091 28 44 28H24V4Z",
    fill: "url(#paint3_linear_396_11251)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.0003 44H24.0003H6.00032C3.79119 44 2.00032 42.2091 2.00032 40V27.4648C2.58867 27.8052 3.27175 28 4.00032 28H24.0003H44.0003C44.7127 28 45.3816 27.8138 45.9609 27.4873C45.7281 28.9124 44.4912 30 43.0003 30H27.5003C26.6719 30 26.0003 30.6715 26.0003 31.5C26.0003 32.3284 25.3288 33 24.5003 33H21.5003C20.6719 33 20.0003 32.3284 20.0003 31.5C20.0003 30.6715 19.3288 30 18.5003 30H6.00032C4.34347 30 3.00032 31.3431 3.00032 33V40C3.00032 41.6568 4.34347 43 6.00032 43H43.1462C44.1501 43 45.0778 42.4989 45.6308 41.6814C44.9957 43.0505 43.6089 44 42.0003 44Z",
    fill: "url(#paint4_linear_396_11251)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 1,
    width: 12,
    height: 3,
    rx: 1,
    fill: "url(#paint5_linear_396_11251)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8C0 5.79086 1.79086 4 4 4H44C46.2091 4 48 5.79086 48 8V24C48 26.2091 46.2091 28 44 28H23V27H44C45.6569 27 47 25.6569 47 24V8C47 6.34315 45.6569 5 44 5H4C2.34315 5 1 6.34315 1 8V24C1 25.6569 2.34314 27 4 27H20V28H4C1.79086 28 0 26.2091 0 24V8Z",
    fill: "url(#paint6_radial_396_11251)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8C0 5.79086 1.79086 4 4 4H44C46.2091 4 48 5.79086 48 8V24C48 26.2091 46.2091 28 44 28H23V27H44C45.6569 27 47 25.6569 47 24V8C47 6.34315 45.6569 5 44 5H4C2.34315 5 1 6.34315 1 8V24C1 25.6569 2.34314 27 4 27H20V28H4C1.79086 28 0 26.2091 0 24V8Z",
    fill: "url(#paint7_radial_396_11251)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8C0 5.79086 1.79086 4 4 4H44C46.2091 4 48 5.79086 48 8V24C48 26.2091 46.2091 28 44 28H23V27H44C45.6569 27 47 25.6569 47 24V8C47 6.34315 45.6569 5 44 5H4C2.34315 5 1 6.34315 1 8V24C1 25.6569 2.34314 27 4 27H20V28H4C1.79086 28 0 26.2091 0 24V8Z",
    fill: "url(#paint8_radial_396_11251)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21 26C21 24.8954 21.8954 24 23 24H25C26.1046 24 27 24.8954 27 26V30C27 31.1046 26.1046 32 25 32H23C21.8954 32 21 31.1046 21 30V26Z",
    fill: "url(#paint9_linear_396_11251)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 24C21.8954 24 21 24.8954 21 26V30C21 31.1046 21.8954 32 23 32H25C26.1046 32 27 31.1046 27 30V26C27 24.8954 26.1046 24 25 24H23ZM23 25C22.4477 25 22 25.4477 22 26V30C22 30.5523 22.4477 31 23 31H25C25.5523 31 26 30.5523 26 30V26C26 25.4477 25.5523 25 25 25H23Z",
    fill: "url(#paint10_radial_396_11251)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 24C21.8954 24 21 24.8954 21 26V30C21 31.1046 21.8954 32 23 32H25C26.1046 32 27 31.1046 27 30V26C27 24.8954 26.1046 24 25 24H23ZM23 25C22.4477 25 22 25.4477 22 26V30C22 30.5523 22.4477 31 23 31H25C25.5523 31 26 30.5523 26 30V26C26 25.4477 25.5523 25 25 25H23Z",
    fill: "url(#paint11_radial_396_11251)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 2V3C30 3.55228 29.5523 4 29 4H19C18.4477 4 18 3.55228 18 3V2C18 2.55228 18.4477 3 19 3H29C29.5523 3 30 2.55228 30 2Z",
    fill: "url(#paint12_linear_396_11251)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_396_11251",
    x: -4,
    y: 0,
    width: 32,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_396_11251"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_396_11251",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_396_11251",
    x: 20,
    y: 0,
    width: 32,
    height: 32,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_396_11251"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_396_11251",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_396_11251",
    x1: 2,
    y1: 6,
    x2: 52.7476,
    y2: 20.6901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_396_11251",
    x1: 2,
    y1: -25.0909,
    x2: 64.9312,
    y2: 8.03076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_396_11251",
    x1: 0,
    y1: 28,
    x2: 0,
    y2: 4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CA0B8",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5D4E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_396_11251",
    x1: 24,
    y1: 35,
    x2: 24,
    y2: 4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CA0B8",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C5D4E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_396_11251",
    x1: 23.9806,
    y1: 27.4648,
    x2: 23.9806,
    y2: 44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF9191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF9191",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_396_11251",
    x1: 18,
    y1: 1,
    x2: 24,
    y2: 13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA800"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_396_11251",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47 5) rotate(135) scale(19.0919)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_396_11251",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.5 7) rotate(71.5651) scale(12.6491)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_396_11251",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16 23.5) rotate(-93.8141) scale(7.51665 38.468)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EC9A93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFACA5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_396_11251",
    x1: 24,
    y1: 24,
    x2: 24,
    y2: 32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5D4E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFC1D6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_396_11251",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27 24) rotate(135) scale(4.24264)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_396_11251",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28 27) rotate(-180) scale(4 6.3923)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_396_11251",
    x1: 24,
    y1: 2,
    x2: 24,
    y2: 4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF9191"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BF9191",
    stopOpacity: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenerLogo);
export default __webpack_public_path__ + "static/media/ScreenerLogo.4bceccd99cd51d9214a6426606f84703.svg";
export { ForwardRef as ReactComponent };